<template>
    <section class="container">
      <div class="fondoLogo">
        <div class="logoHome">
          <img src="../assets/img/IconoImagenEurocaja.png" alt="ImagenEurocaja">
        </div>
        <div class="textoLogo">
          Portal Proveedores Confirming
          <p>Bienvenido, {{usuario}}</p>
        </div>
      </div>
    </section>
</template>

<script>
export default {
    name : 'HomeComponent',
    data() {
      return {
        usuario : this.$cookies.get('userName')
      }
    }
}
</script>